import * as api from './api';

// Refresh the persisted client session against the API, or clear it if it is
// no longer valid.
//
// `api.get` resolves to `undefined` on any non-2xx response (see utils/api.jsx:
// the request rejects on non-2xx, is caught, and the catch returns nothing).
// The common case is a 404 when the persisted session points at a client that
// no longer exists (e.g. after the account was removed). Guarding the response
// makes a stale session self-heal (unsetClient) instead of throwing on `.id`;
// this mirrors the `client &&` guard already used in RoutesForReal._prefillFields.
async function reloadPersistedClient({ client, setClient, unsetClient }) {
  if (!client || !client.id) return;

  const fresh = await api.get(`/clients/${client.id}`);
  if (fresh && fresh.id) setClient(fresh);
  else unsetClient();
}

export default reloadPersistedClient;
